import { Input, Radio, Space, FormProps, Checkbox } from 'antd';

import Form from './Form';

export interface AccessProfileFormValues {
  name: string;
  viewAllVacancies: boolean;
  createAndEditVacancies: boolean;
  accessTalentPool: boolean;
  accessConfigurations: boolean;
  accessReports: boolean;
  viewRequestJobPosting: string;
  createAndEditRequestJobPosting: boolean;
  canApproveRequestJobPosting: boolean;
}

const AccessProfileForm = ({ ...props }: FormProps) => {
  const viewAllVacanciesValue = Form.useWatch<AccessProfileFormValues['viewAllVacancies']>(
    'viewAllVacancies',
    props.form
  );

  const viewRequestJobPostingValue = Form.useWatch<
    AccessProfileFormValues['viewRequestJobPosting']
  >('viewRequestJobPosting', props.form);

  return (
    <Form<AccessProfileFormValues> {...props}>
      <Form.Item
        label="Nome"
        name="name"
        rules={[
          { required: true },
          {
            validator: (rule, value: string) => {
              if (value === 'Padrão') {
                return Promise.reject(
                  new Error(
                    'O nome "Padrão" é reservado para uso do sistema. Por favor, escolha outro nome para o perfil.'
                  )
                );
              }

              return Promise.resolve();
            },
          },
        ]}
      >
        <Input />
      </Form.Item>
      <Form.Legend>Permissões:</Form.Legend>
      <Form.Item
        shouldUpdate={(prev, next) => prev.viewAllVacancies !== next.viewAllVacancies}
        noStyle
      >
        {(form) => (
          <Form.Item label="Acesso às vagas" name="viewAllVacancies" rules={[{ required: true }]}>
            <Radio.Group
              onChange={(e) => {
                if (!e.target.value) {
                  form.setFieldsValue({ accessReports: false });
                }
              }}
            >
              <Space direction="vertical">
                <Radio value={false}>Visualizar apenas vagas marcadas</Radio>
                <Radio value>Visualizar todas as vagas</Radio>
              </Space>
            </Radio.Group>
          </Form.Item>
        )}
      </Form.Item>
      <Form.Item
        label="Acesso às requisições"
        name="viewRequestJobPosting"
        rules={[{ required: true }]}
      >
        <Radio.Group
          onChange={(e) => {
            if (e.target.value === 'FORBID') {
              props.form?.setFieldsValue({
                createAndEditRequestJobPosting: false,
                canApproveRequestJobPosting: false,
              });
            }
          }}
        >
          <Space direction="vertical">
            <Radio value="FORBID">Sem acesso a requisições</Radio>
            <Radio value="MARKED">Visualizar apenas as requisições marcadas</Radio>
            <Radio value="ALL">Visualizar todas as requisições</Radio>
          </Space>
        </Radio.Group>
      </Form.Item>
      <Form.Item label="Acesso às funcionalidades">
        <Space direction="vertical">
          <Form.Item name="createAndEditVacancies" valuePropName="checked" noStyle>
            <Checkbox>Criação e Edição de Vagas</Checkbox>
          </Form.Item>
          <Form.Item name="accessTalentPool" valuePropName="checked" noStyle>
            <Checkbox>Banco de Talentos</Checkbox>
          </Form.Item>
          <Form.Item name="accessConfigurations" valuePropName="checked" noStyle>
            <Checkbox>Configurações</Checkbox>
          </Form.Item>
          <Form.Item name="accessReports" valuePropName="checked" noStyle>
            <Checkbox disabled={!viewAllVacanciesValue}>Relatórios</Checkbox>
          </Form.Item>
          <Form.Item name="createAndEditRequestJobPosting" valuePropName="checked" noStyle>
            <Checkbox
              disabled={!viewRequestJobPostingValue || viewRequestJobPostingValue === 'FORBID'}
            >
              Criação e Edição de requisições
            </Checkbox>
          </Form.Item>
          <Form.Item name="canApproveRequestJobPosting" valuePropName="checked" noStyle>
            <Checkbox
              disabled={!viewRequestJobPostingValue || viewRequestJobPostingValue === 'FORBID'}
            >
              Aprovar requisições
            </Checkbox>
          </Form.Item>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default AccessProfileForm;
